import PageLayout from "../components/PageLayout.jsx";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import React from "react";

export default function NotFound() {
  const { t } = useTranslation();
  return (
    <PageLayout title="Not Found - 404" isFullWidth={true}>
      <div className="dark relative bg-gray-800 px-6 py-4 text-white transition-[padding] sm:px-12 sm:py-10 md:py-15 lg:px-16 lg:py-20">
        <div aria-hidden="true" className="bg-opacity-80 absolute inset-0 bg-gray-900"></div>
        <div className="relative mx-auto flex max-w-full flex-col items-center text-center">
          {/*<img className="object-cover h-24 mb-10" src="/images/proof-logo.png" alt={t('proof.title')}/>*/}
          <h1>{t("404.title")}</h1>
          <p className="mt-4">{t("404.text")}</p>
          <Link className="button button-purple mt-8 self-center" to="/">
            {t("404.linkText")}
          </Link>
        </div>
      </div>
    </PageLayout>
  );
}
